import React from 'react';
export class PureComponentWithChildren extends React.PureComponent {
}
export const withChildren = (Component) => {
    return Component;
};
export class ComponentWithChildren extends React.Component {
}
//# sourceMappingURL=react.js.map